export default __webpack_public_path__ + "static/media/fMaltoBuza23.d1475e57.png";